/**
 * CRO-WEB-169 Experiment Configuration
 *
 * Configuration for the premium-to-onboarding redirect experiment.
 */

import type { ExperimentConfig } from "@/src/experiments/useExperimentTracking";
import { getCroWeb169VariantFromCookie } from "./getCroWeb169Variant";

export const croWeb169Config: ExperimentConfig = {
  name: "cro-web-169",
  getVariant: getCroWeb169VariantFromCookie,
  eventName: "cro_web_169_experiment_page_view",
  featureFlagName: "cro-web-169",
};
